import { useContext } from "react";
import SelectableButton from "src/components/buttons/SelectableButton/SelectableButton";
import { GridKeikka_NewKeikkaContext } from "src/context/GridKeikka_NewKeikkaContext";
import "../gridKeikka_NewKeikka_Styles.css";
import { BetoniIcon } from "src/components/icons/TuoteIcons";
import GridKeikka_NewKeikka_AsiakasSelector_HeaderDiv from "../../GridKeikkaEditor/components/GridKeikka_NewKeikka_AsiakasSelector_HeaderDiv";
import PropTypes from "prop-types";
import { AddIcon } from "src/components/icons/ActionIcons";

export default function GridKeikka_NewKeikka_BetoniAsiakasSelector({ onAddClick = () => {} }) {
  const { betoniAsiakas, setBetoniAsiakas, betoniAsiakasList } = useContext(
    GridKeikka_NewKeikkaContext
  );

  const handleAddClick = () => onAddClick("betoni");

  return (
    <div className="newKeikka_paper">
      <GridKeikka_NewKeikka_AsiakasSelector_HeaderDiv
        title="Betonivalmistaja"
        Icon={BetoniIcon}
        ButtonIcon={AddIcon}
        onAddClick={handleAddClick}
        size="small"
        tooltipProps={{ title: "Lisää uusi betonivalmistaja", placement: "top" }}
      />
      <div className="newKeikka_buttonList">
        {betoniAsiakasList.map(
          (asiakas) =>
            asiakas?.betoniAsiakasId > 0 && (
              <SelectableButton
                key={asiakas.betoniAsiakasId}
                checked={betoniAsiakas?.betoniAsiakasId === asiakas.betoniAsiakasId}
                onClick={() => setBetoniAsiakas(asiakas)}>
                {asiakas.betoniAsiakasNimi.toUpperCase()}
              </SelectableButton>
            )
        )}
      </div>
    </div>
  );
}

GridKeikka_NewKeikka_BetoniAsiakasSelector.propTypes = {
  onAddClick: PropTypes.func,
};
